/**
 * Ordering helpers for tag search results.
 *
 * Tags have no creation timestamp, but many follow a "<year> <name>" pattern
 * (e.g. "2024 Vegas trip"). When fuzzy-search scores tie, prefer the tag with
 * the most recent year so typing "Vegas" suggests the newest trip first.
 */

const YEAR_PATTERN = /\b(?:19|20)\d{2}\b/;

export const extractYear = (name: string): number | null => {
  const match = YEAR_PATTERN.exec(name);
  return match ? Number(match[0]) : null;
};

export const compareTagsNewestFirst = (
  a: {name: string},
  b: {name: string},
): number => {
  const yearA = extractYear(a.name);
  const yearB = extractYear(b.name);
  if (yearA !== null && yearB !== null && yearA !== yearB) {
    return yearB - yearA;
  }
  return a.name.localeCompare(b.name);
};
